<template>
    <div class="banner">
        <swiper ref="swiper" :options="options" v-if="data.length > 0">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">
                    <!-- <img :src="item.image" alt=""> -->
                    <a :href="item.url" target="_blank" v-if="item.url">
                        <div class="cover pc" :style="`background-image: url(${item.image});`"></div>
                        <div class="cover mobile" :style="`background-image: url(${item.web_image});`"></div>
                        <div class="container">
                            <div class="title_top">{{item.top_title}}</div>
                            <div class="content">
                                <div class="icon" :style="`background-image: url(${item.icon});`"></div>
                                <div class="title" v-html="textToHtml(item.title)"></div>
                                <div class="desc" v-html="textToHtml(item.desc)"></div>
                            </div>
                        </div>
                    </a>
                    <template v-else>
                        <div class="cover pc" :style="`background-image: url(${item.image});`"></div>
                        <div class="cover mobile" :style="`background-image: url(${item.web_image});`"></div>
                        <div class="container">
                            <div class="title_top">{{item.top_title}}</div>
                            <div class="content">
                                <div class="icon" :style="`background-image: url(${item.icon});`"></div>
                                <div class="title" v-html="textToHtml(item.title)"></div>
                                <div class="desc" v-html="textToHtml(item.desc)"></div>
                            </div>
                        </div>
                    </template>
                </swiper-slide>
            </template>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
        <div class="arrow_down"></div>
    </div>
</template>

<script>
import { swiper, swiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import lineBreaks from '../../utils/lineBreaks';
export default {
    name: "indexBanner",
    props: [ 'data' ],
    data() {
        return {
            options: {
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                speed: 500,
                loop: true,
                resistanceRatio: 0,
                navigation: {
                    prevEl: '.banner .swiper-button-prev',
                    nextEl: '.banner .swiper-button-next',
                },
                observer: true,
                observeParents: true,
            },
        };
    },
    computed: {
        textToHtml: lineBreaks.textToHtml,
        swiper() {
            return this.$refs.swiper.swiper
        },
    },
    components: {
        swiper,
        swiperSlide,
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.banner{
    position: relative;
    .swiper-slide{
        transform: translate3d(0,0,0);
        overflow: hidden;
    }
    .container{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        color: #fff;
        padding: 6.25% 0 7.8125%;
        .title_top{
            font-size: .74rem;
            font-family: 'shuionworkx';
            letter-spacing: .2em;
            .sup{
                font-size: .28rem;
                vertical-align: super;
            }
        }
        .content{
            .icon{
                width: .5rem;
                height: .5rem;
                margin-bottom: .2rem;
                background: no-repeat center/cover;
            }
            .title{
                font-size: .38rem;
                white-space: pre;
                margin-bottom: .2rem;
            }
            .desc{
                width: 3.5rem;
                line-height: 1.8;
            }
        }
        @media only screen and (max-width: 1200px) {
            padding: .8rem 1rem 3rem;
            .title_top{
                font-size: 1.5rem;
                text-align: center;
            }
            .content{
                .icon{
                    width: 1.3rem;
                    height: 1.3rem;
                    margin-bottom: .5rem;
                }
                .title{
                    font-size: .72rem;
                    margin-bottom: .5rem;
                }
                .desc{
                    width: 100%;
                }
            }
        }
    }
    .cover{
        width: 100%;
        // height: 9.8rem;
        padding-bottom: 51.04%;
        background: no-repeat center/cover;
        &.mobile{
            display: none;
        }
        @media only screen and (max-width: 1200px) {
            &.pc{
                display: none;
            }
            &.mobile{
                display: block;
                height: 21.98rem;
                padding-bottom: 0;
            }
        }
    }
    .swiper-button-prev,
    .swiper-button-next{
        width: .24rem;
        height: .3rem;
        margin-top: 0;
        transform: translate3d(0, -50%, 0);
        background: no-repeat 0/100%;
        outline: none;
        &::after{
            display: none;
        }
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: .8rem;
        background-image: url('~@/assets/images/icon_arrow_prev.svg');
    }
    .swiper-button-next{
        right: .8rem;
        background-image: url('~@/assets/images/icon_arrow_next.svg');
    }
    .arrow_down{
        position: absolute;
        z-index: 1;
        left: 50%;
        bottom: .4rem;
        width: .4rem;
        height: .5rem;
        transform: translate3d(-50%, 0, 0) rotate(90deg);
        background: url('~@/assets/images/icon_arrow_next.svg') no-repeat 0/100%;
    }
    @media only screen and (max-width: 1200px) {
        .swiper-button-prev,
        .swiper-button-next{
            width: .48rem;
            height: .61rem;
        }
        .swiper-button-prev{
            left: .45rem;
        }
        .swiper-button-next{
            right: .45rem;
        }
        .arrow_down{
            width: .57rem;
            height: .7rem;
            bottom: 1.24rem;
        }
    }
}
</style>